import { Close } from "@mui/icons-material";
import { Box, IconButton, TextField } from "@mui/material";
import MDAutocomplete from "components/MDAutocomplete";
import { DatePicker } from "@mui/x-date-pickers";
import { formatPhoneNumber, formatToPhoneNumber } from "layouts/pages/tenants/tenant-admin";
import moment from "moment";
import React from "react";
// import { Input, CustomInput } from "reactstrap";

export const Filter = ({ column }) => {
  return <div style={{ marginTop: 5 }}>{column.canFilter && column.render("Filter")}</div>;
};

export const DefaultColumnFilter = ({
  column: { filterValue, setFilter, filterInputType, filterOptions, id, Header, ...rest },
}) => {
  const getPlaceholder = (header) => `Filter by ${header.toLowerCase()}`;

  let inputComponent = null;

  switch (filterInputType) {
    case "text":
      inputComponent = (
        <TextField
          type="text"
          value={Header.toLowerCase() === "phone" && filterValue ? formatToPhoneNumber(filterValue) : filterValue || ""}
          size="small"
          variant="outlined"
          placeholder={getPlaceholder(Header)}
          onChange={(e) => {
            if (Header.toLowerCase() === "phone") {
              setFilter(e.target.value ? formatPhoneNumber(e.target.value) : undefined);
            } else {
              setFilter(e.target.value || undefined);
            }
          }}
          InputProps={{
            endAdornment: (
              <IconButton
                disabled={!filterValue}
                size="small"
                onClick={() => {
                  setFilter(undefined);
                }}
              >
                <Close />
              </IconButton>
            ),
          }}
        />
      );
      break;
    case "number":
      inputComponent = (
        <TextField
          type="number"
          value={filterValue || ""}
          size="small"
          variant="outlined"
          placeholder={getPlaceholder(Header)}
          onChange={(e) => {
            const value = e.target.value;
            // Check for valid number format - only one decimal point and one negative sign at start
            if (value === "" || /^-?\d*\.?\d*$/.test(value)) {
              // Prevent multiple decimal points
              const decimalCount = (value.match(/\./g) || []).length;
              // Prevent multiple negative signs and only allow negative at start
              const negativeCount = (value.match(/-/g) || []).length;
              
              if (decimalCount <= 1 && negativeCount <= 1 && (!value.includes('-') || value.indexOf('-') === 0)) {
                setFilter(value || undefined);
              }
            }
          }}
          onKeyDown={(e) => {
            // Get current value
            const currentValue = e.target.value;
            
            // Prevent multiple decimal points
            if (e.key === '.' && currentValue.includes('.')) {
              e.preventDefault();
              return;
            }
            
            // Prevent multiple negative signs or negative sign in middle
            if (e.key === '-') {
              if (currentValue.includes('-') || e.target.selectionStart > 0) {
                e.preventDefault();
                return;
              }
            }
            
            // Allow negative sign, decimal point, numbers, and control keys
            if (!/[-\d.]/.test(e.key) && 
                e.key !== 'Backspace' && 
                e.key !== 'Delete' && 
                e.key !== 'ArrowLeft' && 
                e.key !== 'ArrowRight' &&
                e.key !== 'Tab') {
              e.preventDefault();
            }
          }}
          InputProps={{
            endAdornment: (
              <IconButton
                disabled={!filterValue}
                size="small"
                onClick={() => {
                  setFilter(undefined);
                }}
              >
                <Close />
              </IconButton>
            ),
          }}
        />
      );
      break;
    case "select":
      inputComponent = (
        <MDAutocomplete
          value={filterValue || null}
          options={filterOptions}
          onChange={(e, newValue) => {
            setFilter(newValue || undefined);
          }}
          placeholder={getPlaceholder(Header)}
          size="small"
          sx={{ width: "auto", minWidth: 150 }}
          renderInput={(params) => <TextField {...params} placeholder={getPlaceholder(Header)} />}
          renderOption={(props, option) => (
            <li {...props} key={option?.id ?? option?.value}>
              {option.label}
            </li>
          )}
        />
      );
      break;
    case "date":
      const date = filterValue ? moment(filterValue) : null;
      inputComponent = (
        <DatePicker
          value={date}
          onChange={(newValue) => {
            if (newValue) {
              const changedDate = moment(newValue).format("YYYY-MM-DD");
              setFilter(changedDate);
            } else {
              setFilter(undefined);
            }
          }}
          sx={{ width: 200 }}
          format="MM/DD/YYYY"
          inputRef={{ size: "small" }}
          slotProps={{
            textField: {
              size: "small",
              clearable: true,
              onClear: (event) => {},
            },
          }}
          disableFuture={rest.disableFuture}
        />
      );
      break;
    default:
      inputComponent = (
        <>
          <Box sx={{ mb: 4.5 }}></Box>
        </>
      );
  }

  //   return (
  //     <TextField
  //       value={filterValue || ""}
  //       onChange={(e) => {
  //         setFilter(e.target.value || undefined);
  //       }}
  //       placeholder={`Filter by ${id}`}
  //     />
  //   );
  return inputComponent;
};
